import { Fragment, useCallback, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

import { getQueryParamValue } from 'src/lib/browser';
import { captureMessage } from 'src/lib/sentry';
import { ROUTE_PARAMS, ROUTES } from 'src/routes';
import { useCustomerActions, useUserActions } from 'src/store';
import Authentication from 'src/utils/Authentication';

import { SignInPage } from './SignInPage';

const Container = () => {
  const userActions = useUserActions();
  const customerStoreActions = useCustomerActions();

  const login = useCallback(
    async (queryToken) => {
      try {
        await userActions.loginWithToken(queryToken);
        window.location.href = getQueryParamValue(ROUTE_PARAMS.redirectTo) || ROUTES.ROOT;
      } catch (error) {
        captureMessage("Couldn't log in with token", {
          level: 'warning',
          extra: {
            error: error.toString(),
            source: 'SignInPage/Container -> login',
          },
        });
      }
    },
    [userActions]
  );

  const selectCurrentCustomer = useCallback(
    async (customerId) => {
      try {
        await customerStoreActions.selectCurrentCustomer(customerId);
      } catch (error) {
        captureMessage("Couldn't select customer", {
          level: 'warning',
          extra: {
            error: error.toString(),
            source: 'SignInPage/Container -> selectCurrentCustomer',
          },
        });
      }
    },
    [customerStoreActions]
  );

  useEffect(() => {
    const queryToken = Authentication.getQueryToken();
    if (queryToken) {
      login(queryToken);
    }
    const customerId = Number(getQueryParamValue(ROUTE_PARAMS.customerId));
    if (customerId) {
      selectCurrentCustomer(customerId);
    }
  }, [login, selectCurrentCustomer]);

  return (
    <Fragment>
      <Helmet>
        <title>Log in</title>
      </Helmet>

      <SignInPage />
    </Fragment>
  );
};

Container.propTypes = {};
Container.defaultProps = {};

export default Container;
